import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[footer-page-size-dropdown-template]' })
export class FooterPageSizeDropDownTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
